import React from 'react';
import Button from '@atlaskit/button/standard-button';
import Heading from '@atlaskit/heading';
import MoreIcon from '@atlaskit/icon/core/show-more-horizontal';
import { Box } from '@atlaskit/primitives/compiled';
import {
	AdControlDropdownMenu,
	AdControlProvider,
	DismissalButton,
	ReasonsButton,
} from '@atlassian/ad-control-toolkit';
import { useIntl } from '@atlassian/jira-intl';
import { ContextualAnalyticsData, MODAL } from '@atlassian/jira-product-analytics-bridge';
import { messages } from '../messages.tsx';
import AdControlsReasonsModal from './index.tsx';

type Props = {
	onDismissClick: () => Promise<void>;
};

const AdControls = ({ onDismissClick: onClickDismiss }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<AdControlProvider>
			<AdControlDropdownMenu
				itemId="discover-ideas-issue-view-ad-controls"
				trigger={({ triggerRef, ...props }) => (
					<Box paddingInline="space.050">
						<Button
							{...props}
							testId="issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.menu-button"
							appearance="subtle"
							spacing="compact"
							iconBefore={<MoreIcon color="currentColor" label="more" spacing="none" />}
							ref={triggerRef}
							interactionName="auto-generated.issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.button"
						/>
					</Box>
				)}
			>
				{(props) => (
					<>
						<DismissalButton
							{...props}
							testId="issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.discover-ideas-issue-view-ad-controls-dismissal-button"
							flagProps={{
								title: formatMessage(messages.dismissFlagTitle),
								description: formatMessage(messages.dismissFlagDescription),
							}}
							onClick={onClickDismiss}
						/>
						<ReasonsButton
							{...props}
							testId="issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.discover-ideas-issue-view-ad-controls-reasons-button"
							itemId="discover-ideas-issue-view-ad-controls-reasons"
							modalProps={{
								title: <Heading size="medium">{formatMessage(messages.reasonsModalTitle)}</Heading>,
								body: (
									<ContextualAnalyticsData sourceName="adControlsReasons" sourceType={MODAL}>
										<AdControlsReasonsModal />
									</ContextualAnalyticsData>
								),
							}}
						/>
					</>
				)}
			</AdControlDropdownMenu>
		</AdControlProvider>
	);
};

export default AdControls;
